import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

export const UserPresentationLoader = ({ isLastUser }) => (
  <Box mb={isLastUser ? 0 : 5}>
    <Skeleton height={60} mr={4} width={60} css="border-radius: 50%;" />
    <Box
      flex={1}
      flexDirection="row"
      alignItems="flex-start"
      justifyContent="space-between"
      width="100%"
    >
      <Box
        height="100%"
        width="100%"
        flexDirection="column"
        justifyContent="center"
      >
        <Skeleton width="45%" />
        <Skeleton width="60%" mt={2} />
      </Box>
    </Box>
  </Box>
);
